// Die Schutzstufe, von der Oberfläche aus gesehen
// (internal/api/schutzstufe.go, docs/security-hardening.md).
//
// Der Server beantwortet eine geschützte Aktion ohne Vault-PIN mit
// 423 {"locked": true, "stufe": true}. Was die Oberfläche dann zeigen
// soll, hängt nicht an der Seite, die gefragt hat -- es ist immer
// dasselbe: die PIN-Eingabe (PinAnfrage.svelte).
//
// Darum hängt das Erkennen UNTER allen Anfragen, an fetch selbst. Im
// ersten Anlauf saß es in lib/api.ts; ein gutes Drittel der geschützten
// Aktionen (Agenten, SSH-Ziele, Aufgaben löschen) ruft fetch aber direkt
// und hätte nur "HTTP 423" gezeigt. Eine neue Aktion bekommt die Abfrage
// so von selbst, egal wie sie fragt.
//
// Antworten OHNE "stufe" gehören Seiten mit eigenem Tor (Vault,
// Zeitreise, Dateien, Terminal, Ablage) -- die bleiben unberührt.

export const PIN_NOETIG = "v2:pin-noetig";

let eingehaengt = false;

export function installPinStufe(): void {
  if (eingehaengt || typeof window === "undefined") return;
  eingehaengt = true;
  const echt = window.fetch.bind(window);
  window.fetch = async (...args: Parameters<typeof fetch>): Promise<Response> => {
    const r = await echt(...args);
    if (r.status === 423) {
      // Am Abbild lesen: den Körper der Antwort braucht der Aufrufer selbst.
      r.clone()
        .json()
        .then((j: unknown) => {
          if ((j as { stufe?: unknown } | null)?.stufe === true) {
            window.dispatchEvent(new CustomEvent(PIN_NOETIG));
          }
        })
        .catch(() => {
          // kein JSON -- dann ist es keine Antwort der Schutzstufe
        });
    }
    return r;
  };
}
